<template>
  <div class="ds-control mobile ds_teas_resources_list">
    <div class="head" v-if="!isDesign">
      <div class="head_screen time_color" @click="chooseDate">
        <span>{{nowDate | getDate}}</span>
        <i class="iconfont icon-xiajiantou"></i>
      </div>
      <div class="head_screen " @click="chooseField">
        <span>{{fieldName || '场地'}}</span>
        <i class="iconfont icon-xiajiantou"></i>
      </div>
    </div>
    <div class="head_zw"></div>
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length > 0">
        <van-list v-model="loading" :finished="finished" :error.sync="error" finished-text="没有更多了" @load="getList">
          <div class="list">
            <DsfMobileTeasCell v-for="(item, index) in list" :titleEllipsis="2" @click.native="itemClick(item)" :key="index" :title="item.name || item.relName || '无'">
              <DsfMobileTeasCellItem icon="icon-icon-sb" :value="getMedia(item) || '暂无'"></DsfMobileTeasCellItem>
              <DsfMobileTeasCellItem icon="icon-icon-num" :value="item.num+'人' || '0人'"></DsfMobileTeasCellItem>
              <div slot="titleRight" class="attendance">
                <i class="iconfont icon-weibiaoti34"></i>
              </div>
              <div slot="ft" class="bottom_wb">
                <div class="wb_value" :class="getIcon(item,noonItem)+'-color'" v-for="(noonItem,noonIndex) of noons" :key="noonIndex" @click.stop="noonClick(item,noonItem)">
                  <!-- state 1.课程占用 2.冲突 3.手动占用 statusValue 1.启用 2.停用 3.维修 -->
                  <i class="iconfont" :class="getIcon(item,noonItem)"></i>
                  <span>{{noonItem.text}}</span>
                </div>
              </div>
            </DsfMobileTeasCell>
          </div>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else description="暂无数据" />
    </div>

    <!-- 选择场地 -->
    <dsf-mobile-select-field :show="showSelectField" @close="showSelectField=false" @choose-data="chooseData"></dsf-mobile-select-field>
    <!-- 占用编辑 -->
    <DsfOccupyDialog :show="showDialog" @close="showDialog=false" :value="dialogDetail" @addValue="addValue" @editValue="editValue" @releaseOccupation="releaseOccupation"></DsfOccupyDialog>
    <DsfOccupyPopup :show="showOccupyEdit" :isEdit="isEdit" @close="showOccupyEdit=false" :value="occupyDetail" @submit="occupySubmit"></DsfOccupyPopup>
    <!-- 时间获取 -->
    <van-popup v-model="showPicker" position="bottom">
      <div style="height:100vh" class="date_box">
        <dsf-mobile-calendar :show="showPicker" :defaultValue="defaultValue" ref="calender" @confirm="onConfirm" @cancel="showPicker = false" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import DsfOccupyDialog from "./occupyDialog.vue";
import DsfOccupyPopup from "./occupyPopup.vue";
const testData = [
  {
    facilityText: null,
    facilityValue: null,
    id: "c846f30d9eee4a84a3917d89c2d520ad",
    name: "博慧楼-博慧104",
    num: 0,
    relName: "博慧104",
    statusText: "启用",
    statusValue: "1",
  },
  {
    facilityText: null,
    facilityValue: null,
    id: "88bdd09c233f42e281aa4414968aed74",
    name: "文欣校区-教室",
    num: 0,
    relName: "教室",
    statusText: "启用",
    statusValue: "1"
  },
];
export default dsf.component({
  name: "DsfMobileResourcesList",
  ctrlCaption: "资源占用列表",
  mixins: [$mixins.control],
  components: { DsfOccupyDialog, DsfOccupyPopup },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      list: [],
      noons: [],
      infoMaps: {},
      showDialog: false,
      dialogDetail: {},
      showSelectField: false,
      showOccupyEdit: false,
      occupyDetail: {},
      isEdit: false,//是否为编辑
      active: 0,
      pid: '',//当前页面id
      nowDate: dsf.date.format(new Date(), 'yyyy-mm-dd'),//当前时间
      showPicker: false, //时间选择控件
      defaultValue: '',//时间选择传入默认值
      fieldName: ''//教室名字
    }
  },
  filters: {
    getDate(val) {
      if (val.length >= 8) {
        let arr = val.split('-');
        let dateValue = new Date(val)
        let weeks = new Array(
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六",
          "周日",
        );
        let weekValue = weeks[dsf.date.getWeekDay(dateValue)];
        return `${arr[1]}月${arr[2]}日(${weekValue})`
      } else {
        return val
      }
    }
  },
  props: {
    sourcesUrl: {
      type: String,
      default: '/resource/occupy/queryResourceOccupyTable',
    },
    weekListUrl: {
      type: String,
      default: '/mobile/resource/occupy/mobile-batchoccupation'
    },
  },
  methods: {
    // 弹窗新增
    addValue(val) {
      this.occupyDetail = val;
      this.isEdit = false;
      this.showDialog = false;
      this.showOccupyEdit = true;
    },
    // 弹窗编辑
    editValue(val) {
      this.occupyDetail = val;
      this.isEdit = true;
      this.showDialog = false;
      this.showOccupyEdit = true;
    },
    releaseOccupation() {
      this.showDialog = false;
      this.getList()
    },
    occupySubmit() {
      this.showOccupyEdit = false;
      this.getList()
    },
    // 打开日期选择控件
    chooseDate() {
      this.showPicker = true;
      this.defaultValue = new Date(this.nowDate)
    },
    // 日期选择确认
    onConfirm(val) {
      this.showPicker = false;
      this.nowDate = dsf.date.format(val, 'yyyy-mm-dd');
      this.getList()
    },
    // 行点击事件
    itemClick(val) {
      this.$router.push({
        path: this.weekListUrl + '?date=' + this.nowDate + '&id=' + val.id + '&name=' + val.name
      })
    },
    // 选择场地
    chooseField() {
      this.selectField = [this.pid]
      this.showSelectField = true;
    },
    // 选择场地回调方法
    chooseData(val) {
      if (val.length) {
        this.fieldName = val[0].inheritName || '';
        this.pid = val[0].id;
        this.getList()
      }
      this.showSelectField = false;
    },
    // 触发详情弹窗
    noonClick(item, noonItem) {
      let key = item.id + '-' + this.nowDate + '-' + noonItem.id;
      if (this.infoMaps[key]) {
        item.date = this.nowDate;
        this.dialogDetail = {
          ...this.infoMaps[key],
          relName: item.relName,
          name: item.name,
          startDate: this.nowDate + ' ' + noonItem.startTime,
          endDate: this.nowDate + ' ' + noonItem.endTime,
        };
        this.showDialog = true;
      } else if (item.statusValue == 1) {
        this.occupyDetail = {
          startDate: this.nowDate + ' ' + noonItem.startTime,
          endDate: this.nowDate + ' ' + noonItem.endTime,
          relName: item.relName,
          name: item.name,
          id: item.id,
          phone: '',
          contacts: '',
          reason: ''
        }
        this.isEdit = false;
        this.showOccupyEdit = true;
      }
    },
    // 获取列表数据
    getList(isRefresh = false) {
      if (this.isDesign) {
        this.finished = true;
        return
      }
      const loading = dsf.layer.loading();
      this.$http
        .get(this.$replace(this.sourcesUrl, this), {
          pid: this.pid,
          startDate: this.nowDate,
          endDate: this.nowDate
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            // if (isRefresh) {
            //   this.list = res.data.list
            // } else {
            //   this.list.push(...res.data.list);
            // }
            // this.finished = res.data.lastPage;
            this.finished = true;
            this.changeData(res.data)
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
            this.finished = true
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
          this.finished = true
        })
        .always(() => {
          this.loading = false
          this.refreshing = false
          dsf.layer.closeLoading(loading);
        });
    },
    // 清洗数据
    changeData(val) {
      let mockData = val;
      this.infoMaps = {};
      mockData.list.map((i) => {
        i.info.map((ite) => {
          let key = ite.resourceId + "-" + i.date + "-" + ite.noon;
          // let key = ite.resourceId;
          this.infoMaps[key] = ite;
        });
      });
      this.list = mockData.resources;
      this.noons = mockData.noons;
    },
    getMedia(val) {
      if (!val.facilityText) return
      let facilityText = val.facilityText.replace(/['^']/g, '、')
      return facilityText
    },
    getIcon(item, noonItem) {
      let key = item.id + '-' + this.nowDate + '-' + noonItem.id;
      if (this.infoMaps[key]) {
        if (this.infoMaps[key].noon == noonItem.id && this.infoMaps[key].resourceId == item.id) {
          if (this.infoMaps[key].state == 1) {
            return 'icon-icon-yk'
          } else if (this.infoMaps[key].state == 2) {
            return 'icon-icon-tips'
          } else if (this.infoMaps[key].state == 3) {
            return 'icon-icon-czr'
          }
        } else {
          return 'icon-icon-kx'
        }
      } else {
        if (item.statusValue == 1) {
          return 'icon-icon-kx'
        } else {
          return 'icon-icon-jy'
        }
      }
    },
    // 刷新
    onRefresh() {
      this.getList()
    },
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.getList();
    }
  },
  mounted() {
  }
})
</script>

<style>
</style>